/**
 * Genera URL de WhatsApp con mensaje predeterminado
 * @param {string} phone - Número de teléfono
 * @param {string} message - Mensaje predeterminado
 * @param {string} pathType - 'api' para móvil, 'web' para desktop
 * @returns {string} URL completa de WhatsApp
 */
export const generateWhatsAppUrl = (phone, message, pathType = 'web') => {
  const encodedMessage = encodeURIComponent(message);
  // return `https://${pathType}.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
  // return `https://web.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`
  return `https://api.whatsapp.com/send/?phone=%2B${phone}&text=${encodedMessage}&type=phone_number&app_absent=0`
};

/**
 * Formatea un número de teléfono para display
 * @param {string} phone - Número de teléfono
 * @returns {string} Teléfono formateado
 */
export const formatPhone = (phone) => {
  return phone.replace(/(\+\d{2})(\d{3})(\d{4})(\d{4})/, '$1 $2 $3-$4');
};
